import { render, staticRenderFns } from "./widget-education.vue?vue&type=template&id=56e021a0"
import script from "./widget-education.vue?vue&type=script&lang=js"
export * from "./widget-education.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports